import { render, staticRenderFns } from "./FixAnomalyModal.vue?vue&type=template&id=115e160d"
import script from "./FixAnomalyModal.vue?vue&type=script&lang=js"
export * from "./FixAnomalyModal.vue?vue&type=script&lang=js"
import style0 from "./FixAnomalyModal.vue?vue&type=style&index=0&id=115e160d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports